import { render, staticRenderFns } from "./ServiceMasterRegisterForm.vue?vue&type=template&id=2294224e&"
import script from "./ServiceMasterRegisterForm.vue?vue&type=script&lang=ts&"
export * from "./ServiceMasterRegisterForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports